import { apiRequest } from "../api/apiClient";
import { User } from "../types/slice.types";

const ROUTE_PREFIX = "userDatas";

const getUsers = async (search: string = "", city: string = "") => {
  const params = new URLSearchParams();
  if (search) params.append("search", String(search));
  if (city) params.append("city", String(city));

  const query = params.toString();
  const { data, error } = await apiRequest("get", `/${ROUTE_PREFIX}?${query}`);

  return { data, error };
};

const removeUser = async (userId: string) => {
  const { data, error } = await apiRequest(
    "delete",
    `/${ROUTE_PREFIX}/${userId}`
  );
  return { data, error };
};

const updateExisitingUser = async (user: User) => {
  const { data, error } = await apiRequest(
    "put",
    `/${ROUTE_PREFIX}/${user._id}`,
    user
  );
  return { data, error };
};

export { getUsers, removeUser, updateExisitingUser };
